const VARIANTS_OF_KEY = Object.freeze({
    A: { ALPHABETICAL: ["a"], KEY_CODE: 65 },
    B: { ALPHABETICAL: ["b"], KEY_CODE: 66 },
    C: { ALPHABETICAL: ["c"], KEY_CODE: 67 },
    D: { ALPHABETICAL: ["d"], KEY_CODE: 68 },
    E: { ALPHABETICAL: ["e"], KEY_CODE: 69 },
    F: { ALPHABETICAL: ["f"], KEY_CODE: 70 },
    G: { ALPHABETICAL: ["g"], KEY_CODE: 71 },
    H: { ALPHABETICAL: ["h"], KEY_CODE: 72 },
    I: { ALPHABETICAL: ["i"], KEY_CODE: 73 },
    J: { ALPHABETICAL: ["j"], KEY_CODE: 74 },
    K: { ALPHABETICAL: ["k"], KEY_CODE: 75 },
    L: { ALPHABETICAL: ["l"], KEY_CODE: 76 },
    M: { ALPHABETICAL: ["m"], KEY_CODE: 77 },
    N: { ALPHABETICAL: ["n"], KEY_CODE: 78 },
    O: { ALPHABETICAL: ["o"], KEY_CODE: 79 },
    P: { ALPHABETICAL: ["p"], KEY_CODE: 80 },
    Q: { ALPHABETICAL: ["q"], KEY_CODE: 81 },
    R: { ALPHABETICAL: ["r"], KEY_CODE: 82 },
    S: { ALPHABETICAL: ["s"], KEY_CODE: 83 },
    T: { ALPHABETICAL: ["t"], KEY_CODE: 84 },
    U: { ALPHABETICAL: ["u"], KEY_CODE: 85 },
    V: { ALPHABETICAL: ["v"], KEY_CODE: 86 },
    W: { ALPHABETICAL: ["w"], KEY_CODE: 87 },
    X: { ALPHABETICAL: ["x"], KEY_CODE: 88 },
    Y: { ALPHABETICAL: ["y"], KEY_CODE: 89 },
    Z: { ALPHABETICAL: ["z"], KEY_CODE: 90 },
    ENTER: { ALPHABETICAL: ["Enter"], KEY_CODE: 13 },
    ESC: { ALPHABETICAL: ["Escape"], KEY_CODE: 27 },
    SPACE: { ALPHABETICAL: ["Space"], KEY_CODE: 32 },
    ARROWLEFT: { ALPHABETICAL: ["ArrowLeft"], KEY_CODE: 37 },
    ARROWUP: { ALPHABETICAL: ["ArrowUp"], KEY_CODE: 38 },
    ARROWRIGHT: { ALPHABETICAL: ["ArrowRight"], KEY_CODE: 39 },
    ARROWDOWN: { ALPHABETICAL: ["ArrowDown"], KEY_CODE: 40 },
    DELETE: { ALPHABETICAL: ["Delete"], KEY_CODE: 46},
    BACKSPACE: { ALPHABETICAL: ["Backspace"], KEY_CODE: 8},
    TAB: { ALPHABETICAL: ["Tab"], KEY_CODE: 9},
    PLUS: { ALPHABETICAL: ["+"], KEY_CODE: 187},
    MINUS: { ALPHABETICAL: ["-"], KEY_CODE: 189},
    CONTROL: { ALPHABETICAL: ["Control"], KEY_CODE: 17 }
});

/**
 * @param { Object } keyInstance
 * @param { Array.<String> } keyInstance.ALPHABETICAL
 * @param { number } keyInstance.KEY_CODE
 * @param { KeyboardEvent } event
 * @returns { boolean }
 */
export function keyPressed(keyInstance, event) {
    return keyInstance.ALPHABETICAL.includes(event.key) || event.keyCode === keyInstance.KEY_CODE;
}

export default VARIANTS_OF_KEY;
